import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { useParams } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { CardHeader, Col, Modal, Row } from 'reactstrap'

const ChecklistModal = (props) => {
  const [showModal, setShowModal] = useState(true)
  const history = useHistory()
  const handleCloseModal = () => setShowModal(false)
  const referredFromManagerReport = new URLSearchParams(
    window.location.search
  ).get('referred_from_manager_report')

  useEffect(() => {
    if (!showModal) {
      if (window.location.href.includes('from_dashboard')) {
        history.push('/')
      } else if (window.location.href.includes('from_notifications')) {
        history.push('/notifications')
      } else if (referredFromManagerReport) {
        history.push(`/manager-report`)
      } else {
        history.push(`/manager-reports/employee/${props.userId}`)
      }
    }
  }, [showModal])

  return (
    <Modal
      isOpen={showModal}
      toggle={handleCloseModal}
      centered
      size={props.size}
      style={props.style}
      className={props.className}
      enforceFocus={false}
      scrollable
    >
      <CardHeader className='py-3'>
        {/* <CardHeader> */}
        <Row className='align-items-center'>
          <Col xs='8'>
            <h5 className='h3 mb-0'>{props.title}</h5>
          </Col>
          <Col className='text-right' xs='4'>
            <FontAwesomeIcon
              icon={faClose}
              size='lg'
              style={{ cursor: 'pointer' }}
              onClick={handleCloseModal}
            />
          </Col>
        </Row>
      </CardHeader>
      {props.children}
    </Modal>
  )
}

export default ChecklistModal
